import { createMuiTheme } from '@material-ui/core/styles';
// @ts-ignore
import commonTheme from '@sprinx/cvo-eshop-ui-common/app/theme';

// Create a theme instance.
const theme = createMuiTheme(commonTheme());

export default theme;
